<form [formGroup]="smsForm">
  <div class="form-cards-wrapper">
    <!-- Campaign policy information -->
    <mat-card class="form-card" formGroupName="campaign">
      <mat-card-header>
        <div class="form-header">
          <mat-card-title>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.TITLE' | translate }}</mat-card-title>
          @if (formLocked && !isCampaignErrorState) {
            <mat-icon>lock</mat-icon>
          }
        </div>
      </mat-card-header>
      <mat-card-content>
        <!-- Privacy Policy URL -->
        <glxy-form-field [required]="true">
          <glxy-label>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.PRIVACY_POLICY_LABEL' | translate }}</glxy-label>
          <input formControlName="privacyPolicyUrl" matInput type="url" />
          <glxy-hint>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.PRIVACY_POLICY_HINT' | translate }}</glxy-hint>
          @if (
            campaignForm.controls.privacyPolicyUrl.hasError('pattern') && campaignForm.controls.privacyPolicyUrl.touched
          ) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.URL_FORMAT_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <glxy-alert type="warning" class="policy-warning-alert">
          <p>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.BODY' | translate }}</strong>
          </p>
          <ul>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIRST_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIRST_TEXT' | translate }}
            </li>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.SECOND_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.SECOND_TEXT' | translate }}
            </li>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.THIRD_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.THIRD_TEXT' | translate }}
            </li>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FOURTH_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FOURTH_TEXT' | translate }}
            </li>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIFTH_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIFTH_TEXT' | translate }}
            </li>
          </ul>
        </glxy-alert>

        <!-- Terms and Conditions URL -->
        <glxy-form-field [required]="true">
          <glxy-label>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.TERMS_AND_CONDITIONS_LABEL' | translate }}</glxy-label>
          <input formControlName="termsAndConditionsUrl" matInput type="url" />
          <glxy-hint>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.TERMS_AND_CONDITIONS_HINT' | translate }}</glxy-hint>
          @if (
            campaignForm.controls.termsAndConditionsUrl.hasError('pattern') &&
            campaignForm.controls.termsAndConditionsUrl.touched
          ) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.URL_FORMAT_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <glxy-alert type="warning" class="policy-warning-alert">
          <p>
            <strong>{{ 'SMS_REGISTRATION.FORM.CAMPAIGN_INFO.TERMS_ALERT_BODY' | translate }}</strong>
          </p>
          <ul>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.FIRST_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.FIRST_TEXT' | translate }}
            </li>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.SECOND_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.SECOND_TEXT' | translate }}
            </li>
            <li>
              <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.THIRD_BOLDED' | translate }}</strong
              >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.THIRD_TEXT' | translate }}
            </li>
          </ul>
        </glxy-alert>
      </mat-card-content>
    </mat-card>

    <mat-card class="form-card" formGroupName="brand">
      <mat-card-header>
        <div class="form-header">
          <mat-card-title>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.TITLE' | translate }}</mat-card-title>
          @if (formLocked) {
            <mat-icon>lock</mat-icon>
          }
        </div>
      </mat-card-header>

      <mat-card-content>
        <!-- Legal business name -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.LEGAL_NAME_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="businessName" matInput />
          @if (!(brandForm.controls.businessName.hasError('maxlength') && brandForm.controls.businessName.touched)) {
            <glxy-hint>
              {{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.LEGAL_NAME_HINT' | translate }}
            </glxy-hint>
          }
          @if (brandForm.controls.businessName.hasError('maxlength') && brandForm.controls.businessName.touched) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.LEGAL_NAME_MAX_LENGTH_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <!-- Business category aka Industry -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.CATEGORY_LABEL' | translate }}</span>
          </glxy-label>
          <mat-select formControlName="businessCategory">
            @for (businessCategory of BusinessCategories; track businessCategory) {
              <mat-option [value]="businessCategory">
                {{ businessCategory | businessCategoryToLabel }}
              </mat-option>
            }
          </mat-select>
        </glxy-form-field>

        <!-- Business type -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.TYPE_LABEL' | translate }}</span>
          </glxy-label>
          <mat-select formControlName="businessType">
            @for (businessType of BusinessTypes; track businessType) {
              <mat-option [value]="businessType">
                {{ businessType }}
              </mat-option>
            }
          </mat-select>
        </glxy-form-field>

        <!-- Country / Region -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.REGION_LABEL' | translate }}</span>
          </glxy-label>
          <mat-select formControlName="regionOfOperation">
            @for (region of Regions; track region) {
              <mat-option [value]="region">{{ region | regionToLabel }}</mat-option>
            }
          </mat-select>
        </glxy-form-field>

        <!-- Business registration number -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.REGISTRATION_NUMBER_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="businessRegistrationNumber" matInput />
          @if (
            !(
              brandForm.controls.businessRegistrationNumber.hasError('pattern') &&
              brandForm.controls.businessRegistrationNumber.touched
            )
          ) {
            <glxy-hint>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.REGISTRATION_NUMBER_HINT' | translate }}</glxy-hint>
          }
          @if (
            brandForm.controls.businessRegistrationNumber.hasError('pattern') &&
            brandForm.controls.businessRegistrationNumber.touched
          ) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.REGISTRATION_NUMBER_HINT' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <!-- Address -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.ADDRESS_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="address" matInput />
        </glxy-form-field>

        <!-- Additional address line -->
        <glxy-form-field>
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.ADDITIONAL_ADDRESS_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="additionalAddressLine" matInput />
        </glxy-form-field>

        <glxy-form-row>
          <!-- State -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.STATE_LABEL' | translate }}</span>
            </glxy-label>
            <input formControlName="state" matInput />
          </glxy-form-field>

          <!-- City -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.CITY_LABEL' | translate }}</span>
            </glxy-label>
            <input formControlName="city" matInput />
          </glxy-form-field>
        </glxy-form-row>

        <!-- Zip code -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.ZIP_CODE_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="zipCode" matInput />
          @if (brandForm.controls.zipCode.hasError('pattern') && brandForm.controls.zipCode.touched) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.ZIP_CODE_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <!-- Website -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.WEBSITE_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="website" matInput type="url" />
          <glxy-hint>{{ 'SMS_REGISTRATION.FORM.BUSINESS_INFO.WEBSITE_HINT' | translate }}</glxy-hint>
        </glxy-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="form-card" formGroupName="brand">
      <mat-card-header>
        <div class="form-header">
          <mat-card-title>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.TITLE' | translate }}</mat-card-title>
          @if (formLocked) {
            <mat-icon>lock</mat-icon>
          }
        </div>
      </mat-card-header>
      <mat-card-content>
        <glxy-form-row>
          <!-- First name -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.FIRST_NAME_LABEL' | translate }}</span>
            </glxy-label>
            <input formControlName="firstName" matInput />
          </glxy-form-field>

          <!-- Last name -->
          <glxy-form-field [required]="true" class="col-xs-12 col-sm-6">
            <glxy-label>
              <span>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.LAST_NAME_LABEL' | translate }}</span>
            </glxy-label>
            <input formControlName="lastName" matInput />
          </glxy-form-field>
        </glxy-form-row>

        <!-- Job position -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.JOB_POSITION_LABEL' | translate }}</span>
          </glxy-label>
          <mat-select formControlName="jobPosition">
            @for (jobPosition of JobPositions; track jobPosition) {
              <mat-option [value]="jobPosition">
                {{ jobPosition }}
              </mat-option>
            }
          </mat-select>
        </glxy-form-field>

        <!-- Business title -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.TITLE_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="businessTitle" matInput />
          <glxy-hint>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.TITLE_HINT' | translate }}</glxy-hint>
        </glxy-form-field>

        <!-- Email -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.EMAIL_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="email" matInput type="email" />
          <glxy-hint>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.EMAIL_HINT' | translate }}</glxy-hint>
          @if (brandForm.controls.email.hasError('email') && brandForm.controls.email.touched) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.EMAIL_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>

        <!-- Phone number -->
        <glxy-form-field [required]="true">
          <glxy-label>
            <span>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.PHONE_LABEL' | translate }}</span>
          </glxy-label>
          <input formControlName="phoneNumber" matInput type="tel" />
          @if (!(brandForm.controls.phoneNumber.hasError('pattern') && brandForm.controls.phoneNumber.touched)) {
            <glxy-hint>
              {{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.PHONE_HINT' | translate }}
            </glxy-hint>
          }
          @if (brandForm.controls.phoneNumber.hasError('pattern') && brandForm.controls.phoneNumber.touched) {
            <glxy-error>{{ 'SMS_REGISTRATION.FORM.AUTHORIZED_REP.PHONE_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>
      </mat-card-content>
    </mat-card>
  </div>
</form>
